import React from 'react';
import { ResultOnly } from './components/AnswerLine';
import { AnimatedEllipsisText } from '@ui/AnimatedEllipsisText';
import styled from 'styled-components';

const ThinkingPositionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;
const ThinkingWrapper = styled.div`
  width: 100%;
  max-width: 400px;
  text-align: left;

  font-size: 14px;
  line-height: 18px;
  opacity: 0.4;
`;
const TemporaryAnswerWrapper = styled.div`
  padding-top: 16px;
  padding-left: 16px;
  width: 100%;
  text-align: left;

  font-size: 14px;
  line-height: 18px;

  opacity: 0.4;
`;
const processingStates = {
  gatherDocs: 'Gathering source documents',
  determineIfAnswerIsGood: 'Determining if answer is complete',
  start: 'Planning',
  unknown: 'Working on an answer',
  writingAnswer: 'Answering',
  complete: 'Complete',
};

const determineProcessingState = (answer) => {
  if (!answer) {
    return 'start';
  }
  if (answer.includes('{"answer_list":[{"Are there any company names')) {
    return 'gatherDocs';
  }
  if (answer.includes('{"answer_list":[{"Is the Query below fully and completely answered')) {
    return 'determineIfAnswerIsGood';
  }
  if (checkIfWritingAnswer(answer)) {
    return 'writingAnswer';
  }

  return 'unknown';
};

const checkIfWritingAnswer = (answer) => {
  try {
    const json = JSON.parse(answer);
    return json.answer?.length > 0;
  } catch (error) {
    return false;
  }
};
const extractAnswer = (answer) => {
  try {
    const json = JSON.parse(answer);
    const embeddedAnswer = json.answer;
    if (!embeddedAnswer || embeddedAnswer.length > 1) {
      return '';
    }
    const result = Object.values(embeddedAnswer[0])[0];
    if (result.slice(0) === '[' || result.slice(0) === '{') {
      return '';
    }
    return result;
  } catch (error) {
    return '';
  }
};

const AgentChatAnswer = ({ answer }) => {
  const [processingState, setProcessingState] = React.useState('unknown');
  const [temporaryAnswer, setTemporaryAnswer] = React.useState(null);

  React.useEffect(() => {
    const state = determineProcessingState(answer);
    if (state === 'writingAnswer') {
      setTemporaryAnswer(extractAnswer(answer));
    }

    if (state !== processingState) {
      setProcessingState(state);
    }
  }, [answer, processingState]);

  const isWorking = typeof answer === 'string' && answer.trim().startsWith('{');

  if (isWorking || !answer) {
    return (
      <>
        <ThinkingPositionWrapper>
          <ThinkingWrapper>
            <AnimatedEllipsisText text={processingStates[processingState]} />
          </ThinkingWrapper>
        </ThinkingPositionWrapper>
        {temporaryAnswer && (
          <TemporaryAnswerWrapper>
            <ResultOnly result={temporaryAnswer} ignoreLatex />
          </TemporaryAnswerWrapper>
        )}
      </>
    );
  }

  return <ResultOnly result={answer} />;
};

export default AgentChatAnswer;
